import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import * as _ from 'lodash-es';

export const VALIDATION_ERRORS = {
  required: 'This field is required.',
  email: 'Invalid email address (format should be xxx@yyy.zzz)',
  phone: 'Invalid phone number (between 9 and 14 digits, should start with `+`).',
  pattern: 'Please input only numeric values.',
};

@Component({
  selector: 'app-validation-errors',
  templateUrl: './validation-errors.component.html',
  styleUrls: ['./validation-errors.component.css'],
})
export class ValidationErrorsComponent {
  @Input() control: UntypedFormControl;
  errorsS: Subject<any> = new Subject<any>();
  @Input() customErrorMsg = null;
  public errors$ = this.errorsS.asObservable();

  get errorMessages(): string[] {
    const errMsg: string[] = [];

    if (this.customErrorMsg && !_.isEmpty(this.control.errors) && this.control.touched) {
      errMsg.push(this.customErrorMsg);
    } else {
      for (const propertyName in this.control.errors) {
        if (Object.prototype.hasOwnProperty.call(this.control.errors, propertyName) && this.control.touched) {
          errMsg.push(VALIDATION_ERRORS[propertyName]);
        }
      }
    }
    return errMsg;
  }
}
